export const CURRENT_SCHEMA_VERSION = 2;

type SaveMigration = (raw: Record<string, unknown>) => Record<string, unknown>;

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

function migrateV1ToV2(raw: Record<string, unknown>): Record<string, unknown> {
  const game = raw.game;
  if (!isRecord(game) || !isRecord(game.collection)) throw new Error('V1存档缺少图鉴数据。');

  return {
    ...raw,
    schemaVersion: 2,
    game: {
      ...game,
      schemaVersion: 2,
      collection: {
        ...game.collection,
        claimedCategoryRewardIds: [],
      },
    },
  };
}

// Each migration is registered under the version it reads.
const migrations: Partial<Record<number, SaveMigration>> = {
  1: migrateV1ToV2,
};

export function migrateSaveData(raw: unknown): unknown {
  if (!isRecord(raw)) throw new Error('存档不是对象。');
  let migrated = raw;
  const rawVersion = migrated.schemaVersion;
  if (typeof rawVersion !== 'number' || !Number.isInteger(rawVersion) || rawVersion < 1)
    throw new Error('存档版本无效。');
  let version = rawVersion;
  if (version > CURRENT_SCHEMA_VERSION) throw new Error('存档来自更新版本，当前游戏无法读取。');

  while (version < CURRENT_SCHEMA_VERSION) {
    const migrate = migrations[version];
    if (!migrate) throw new Error('缺少从存档版本 ' + version + ' 开始的迁移。');
    migrated = migrate(migrated);
    const nextVersion = migrated.schemaVersion;
    if (typeof nextVersion !== 'number' || nextVersion <= version)
      throw new Error('存档迁移没有产生有效的新版本。');
    version = nextVersion;
  }

  return migrated;
}
